import { useMutation, useQueryClient } from '@tanstack/react-query';
import { decidePcmpProposalMis } from '../api/pcmpProposals.api';
import { PCMP_MIS_DECISION_COPY } from '../constants/pcmpMis.constants';
import type { PcmpMisDecision, PcmpMisDecisionPayload } from '../types/pcmpProposal.types';
import { pcmpActionCallbacks } from '../utils/pcmpActionCallbacks';

export function useDecidePcmpProposalMis(
  proposalId: number,
  decision: PcmpMisDecision,
  onSuccess: () => void,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PcmpMisDecisionPayload) => decidePcmpProposalMis(proposalId, payload),
    ...pcmpActionCallbacks(queryClient, PCMP_MIS_DECISION_COPY[decision].toast, onSuccess),
  });
}
